import React from "react";
import BlogList from "../BlogList";
import "./BlogListPage.css";

const BlogListPage = () => {
    return (
        <div className="blog-list-page-wrapper">
            <div className="blog-list-page-title">
                <h1>Nut Hostel Granada Blog</h1>
            </div>
            <BlogList />
        </div>
    );
};

export default BlogListPage;
